export default __webpack_public_path__ + "static/media/create-diagnosis.fbdf3c88.webp";